import { render, staticRenderFns } from "./activityCategoryGoodsSelectDlg.vue?vue&type=template&id=1a2128d7&scoped=true"
import script from "./activityCategoryGoodsSelectDlg.vue?vue&type=script&lang=js"
export * from "./activityCategoryGoodsSelectDlg.vue?vue&type=script&lang=js"
import style0 from "./activityCategoryGoodsSelectDlg.vue?vue&type=style&index=0&id=1a2128d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2128d7",
  null
  
)

export default component.exports